import { put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import get from 'lodash/get';

import includes from 'lodash/includes';
import { CIRCLE_ACTION_TYPES } from '../../constants';
import { CARE_ROLE } from '../../../../constants/props';
import * as inviteGuardian from '../../invite-guardian';
import * as inviteCaregiver from '../../inviteCaregiver';
import * as inviteToFamilyCircle from '../../inviteToFamilyCircle';
import * as circleOfCare from '../../../board/circleOfCare';
import * as error from '../../../ui/error';
import * as success from '../../../ui/success';
import { targetUserIdSelector } from '../../../context/selectors';
import { ERROR_CODES } from '../../../../constants/errors';

const checkErrorCode = payload =>
  get(payload, 'error.meta.validationErrors.login[0].code') ===
  ERROR_CODES.ALREADY_ASSIGNED;

function* inviteToFamilyWorker({ payload }) {
  const userId = yield select(targetUserIdSelector);
  const role = get(payload, 'role');
  const data = {
    id: userId,
    terms_and_conditions_accepted: 'true',
    care_role: role,
    role: get(payload, 'relationship'),
    login: get(payload, 'emailOrPhone'),
  };

  // invite to family circle with GUARDIAN/PARENT/PROXY role
  if (includes([CARE_ROLE.GUARDIAN, CARE_ROLE.PARENT, CARE_ROLE.PROXY], role)) {
    yield put(inviteGuardian.actions.send(data));
    return;
  }
  // invite to family circle with CAREGIVER role
  if (role === CARE_ROLE.CAREGIVER) {
    yield put(inviteCaregiver.actions.send(data));
    return;
  }
  // invite to family circle
  yield put(inviteToFamilyCircle.actions.send(data));
}

function* inviteToFamilyRejectedWorker({ payload }) {
  yield put(inviteToFamilyCircle.actions.rejected(payload));

  if (checkErrorCode(payload)) {
    yield put({
      type: error.consts.UPDATE,
      payload: { id: 'circles.invites.cares.error' },
    });
  }
}

function* inviteToFamilySucceedWorker({ payload }) {
  yield put(inviteToFamilyCircle.actions.succeed(payload));

  yield put({
    type: success.consts.UPDATE,
    payload: { id: 'circles.invites.common.success' },
  });
}

function* inviteToFamilyCircleWorker({ type, payload }) {
  if (type === inviteToFamilyCircle.consts.REJECTED) {
    if (checkErrorCode(payload)) {
      yield put({
        type: error.consts.UPDATE,
        payload: { id: 'circles.invites.cares.error' },
      });
      return;
    }
    return;
  }

  yield put(circleOfCare.actions.addPendingItem(payload));

  yield put({
    type: success.consts.UPDATE,
    payload: { id: 'circles.invites.common.success' },
  });
}

export default function* circleOfCareActionsSaga() {
  yield takeLatest(
    CIRCLE_ACTION_TYPES.INVITE_TO_FAMILY_CIRCLE,
    inviteToFamilyWorker,
  );
  yield takeEvery(
    [inviteGuardian.consts.REJECTED, inviteCaregiver.consts.REJECTED],
    inviteToFamilyRejectedWorker,
  );
  yield takeEvery(
    [inviteGuardian.consts.SUCCEED, inviteCaregiver.consts.SUCCEED],
    inviteToFamilySucceedWorker,
  );
  yield takeEvery(
    [inviteToFamilyCircle.consts.SUCCEED, inviteToFamilyCircle.consts.REJECTED],
    inviteToFamilyCircleWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/circles/sagas/circle-of-care/invite-to-family-circle-saga.js